import type { Messages } from './en.js';

export const ptBR: Messages = {
  app: {
    name: 'Vammo Issue Tracker',
    fixtureBanner: 'Ambiente de fixtures — dados de exemplo, sem integrações reais e sem mensagens reais.',
    skipToContent: 'Ir para o conteúdo',
  },
  nav: {
    myWork: 'Meu trabalho',
    requests: 'Solicitações',
    work: 'Trabalho',
    projects: 'Projetos',
    teams: 'Times',
    reports: 'Relatórios',
    admin: 'Administração',
    settings: 'Configurações',
    newRequest: 'Nova solicitação',
    newWork: 'Novo item de trabalho',
    search: 'Buscar',
    searchPlaceholder: 'Busque trabalho e solicitações ou digite uma chave…',
    notifications: 'Notificações',
    collapse: 'Recolher menu',
    expand: 'Expandir menu',
    openMenu: 'Abrir navegação',
    signOut: 'Sair',
    theme: 'Tema',
    themeLight: 'Claro',
    themeDark: 'Escuro',
    themeSystem: 'Sistema',
    language: 'Idioma',
    shortcuts: 'Atalhos de teclado',
  },
  repoPicker: {
    workTitle: 'Repositórios vinculados',
    workHint: 'Vincular repositórios adiciona evidências para o trabalho futuro. Episódios concluídos mantêm sua base original.',
    projectTitle: 'Repositórios do projeto',
    projectHint: 'A reconciliação e a cobertura de captura incluem os repositórios anexados aqui.',
    search: 'Buscar repositórios',
    noneSelected: 'Nenhum repositório selecionado.',
    remove: 'Remover {{name}}',
    archived: 'Arquivado',
    edit: 'Editar repositórios',
  },
  translationReport: {
    action: 'Reportar',
    title: 'Reportar esta tradução',
    hint: 'Conte o que está errado. O texto original nunca é alterado.',
    comment: 'O que está errado? (opcional)',
    regenerate: 'Traduzir novamente',
    submit: 'Enviar relato',
    thanks: 'Obrigado, o relato foi registrado',
  },
  languageCorrection: {
    label: 'Idioma original',
    hint: 'Corrija se o texto foi detectado no idioma errado; as traduções são recriadas.',
  },
  conflict: {
    title: 'Outra pessoa salvou antes',
    hint: 'Compare sua alteração com a versão atual e escolha qual manter.',
    field: 'Campo',
    mine: 'Sua alteração',
    current: 'Versão atual',
    applyMine: 'Aplicar minha alteração',
    keepCurrent: 'Manter a versão atual',
    fields: { title: 'Título', descriptionMarkdown: 'Descrição', acceptanceCriteria: 'Critérios de aceitação', priority: 'Prioridade', assigneeId: 'Responsável', labels: 'Etiquetas', type: 'Tipo', originalLocale: 'Idioma original', repositoryIds: 'Repositórios', problemMarkdown: 'Problema', expectedOutcome: 'Resultado esperado' },
  },
  common: {
    removeItem: 'Remover {{name}}',
    save: 'Salvar',
    saving: 'Salvando…',
    cancel: 'Cancelar',
    close: 'Fechar',
    create: 'Criar',
    edit: 'Editar',
    delete: 'Excluir',
    archive: 'Arquivar',
    confirm: 'Confirmar',
    submit: 'Enviar',
    back: 'Voltar',
    next: 'Avançar',
    retry: 'Tentar de novo',
    reload: 'Recarregar',
    loading: 'Carregando…',
    loadMore: 'Carregar mais',
    none: 'Nenhum',
    unassigned: 'Sem responsável',
    unknown: 'Desconhecido',
    optional: 'opcional',
    required: 'Obrigatório',
    yes: 'Sim',
    no: 'Não',
    all: 'Todos',
    me: 'Eu',
    filter: 'Filtrar',
    clearFilters: 'Limpar filtros',
    sort: 'Ordenar',
    openFullPage: 'Abrir página completa',
    copyLink: 'Copiar link',
    linkCopied: 'Link copiado',
    viewOriginal: 'Ver original',
    viewTranslation: 'Ver tradução',
    machineTranslated: 'Tradução automática do {{language}}',
    translating: 'Traduzindo…',
    translationFailed: 'Tradução indisponível; exibindo o original.',
    reportTranslation: 'Reportar tradução',
    noResults: 'Nenhum resultado',
    comingSoon: 'Ainda não disponível',
    reason: 'Motivo',
    reasonPlaceholder: 'Explique a decisão',
    created: 'Criado',
    updated: 'Atualizado',
    by: 'por {{name}}',
    you: 'você',
    changesSaved: 'Alterações salvas',
    actionFailed: 'A ação falhou',
    count_one: '{{count}} item',
    count_other: '{{count}} itens',
    preview: 'Pré-visualizar',
    write: 'Escrever',
    markdownHint: 'Markdown suportado: **negrito**, _itálico_, `código`, listas e links.',
    unsavedChanges: 'Você tem alterações não salvas. Salve ou cancele primeiro.',
    discard: 'Descartar',
    keepEditing: 'Continuar editando',
  },
  errors: {
    title: 'Algo deu errado',
    notFound: 'Não encontrado, ou você não tem acesso.',
    forbidden: 'Você não tem permissão para fazer isso.',
    unauthenticated: 'Sua sessão terminou. Entre novamente para continuar.',
    conflict: 'Outra pessoa alterou isto enquanto isso. Revise a versão mais recente e reaplique sua edição.',
    staleGeneration: 'Existe uma entrega mais recente. Revise o estado atual antes de responder.',
    rateLimited: 'Muitas solicitações. Aguarde um momento.',
    unavailable: 'Este recurso não está disponível agora.',
    offline: 'Você parece estar offline. As alterações não serão salvas até a conexão voltar.',
    validation: 'Corrija os campos destacados.',
    generic: 'Erro inesperado. Referência: {{correlationId}}',
  },
  auth: {
    signIn: 'Entrar com a Vammo',
    signingIn: 'Redirecionando para o login…',
    errorTitle: 'O login não foi concluído',
    errorState: 'O link de login expirou ou já foi usado. Comece de novo.',
    errorSuspended: 'Sua conta está suspensa. Fale com um administrador.',
    errorGeneric: 'Não conseguimos verificar seu login corporativo.',
    tryAgain: 'Tentar de novo',
  },
  status: {
    request: {
      DRAFT: 'Rascunho',
      SUBMITTED: 'Enviada',
      NEEDS_INFORMATION: 'Precisa de informações',
      ACCEPTED: 'Aceita',
      REJECTED: 'Recusada',
      DUPLICATE: 'Duplicada',
      RESOLVED: 'Resolvida',
      NEEDS_ATTENTION: 'Requer atenção',
      CANCELED: 'Cancelada',
    },
    phase: {
      TODO: 'A fazer',
      IN_PROGRESS: 'Em andamento',
      IN_REVIEW: 'Em revisão',
      INTEGRATED: 'Integrado',
      DONE: 'Concluído',
      CANCELED: 'Cancelado',
    },
    priority: { URGENT: 'Urgente', HIGH: 'Alta', NORMAL: 'Normal', LOW: 'Baixa' },
    workType: {
      FEATURE: 'Funcionalidade',
      BUG: 'Bug',
      MAINTENANCE: 'Manutenção',
      INFRASTRUCTURE: 'Infraestrutura',
      RESEARCH: 'Pesquisa',
      ANALYSIS: 'Análise',
      OPERATIONS: 'Operações',
      REVIEW: 'Revisão',
      OTHER: 'Outro',
    },
    policy: { PRODUCTION: 'Entrega em produção', DELIVERABLE: 'Entregável', REVIEWED_DELIVERABLE: 'Entregável revisado' },
    policyHelp: {
      PRODUCTION: 'Concluído apenas quando todas as mudanças necessárias estiverem verificadas em produção.',
      DELIVERABLE: 'Concluído quando o responsável registra o resultado frente aos critérios.',
      REVIEWED_DELIVERABLE: 'Concluído quando um revisor independente aprova o resultado.',
    },
    delivery: { UNKNOWN: 'Entrega desconhecida', NOT_DEPLOYED: 'Não implantado', PARTIAL: 'Implantado parcialmente', DEPLOYED: 'Implantado', REVERTED: 'Revertido' },
    association: { CONFIRMED: 'Confirmado', PROVISIONAL: 'Provisório' },
    visibility: { COMPANY: 'Empresa', RESTRICTED: 'Restrito' },
    visibilityHelp: { COMPANY: 'Visível para todos os colaboradores da Vammo com login.', RESTRICTED: 'Visível apenas para as pessoas, times e grupos selecionados (e administradores).' },
    basis: { AGENT_REPORTED: 'Relatado por agente', HUMAN_REPORTED: 'Relatado', PROVIDER_VERIFIED: 'Verificado', IMPORTED_SOURCE: 'Importado', FIXTURE: 'Fixture' },
    completionBasis: { VERIFIED_PRODUCTION: 'Verificado em produção', DELIVERABLE: 'Entregável registrado', REVIEWED_DELIVERABLE: 'Revisado e aprovado', IMPORTED_SOURCE: 'Concluído no Jira (importado)' },
    confirmation: { UNCONFIRMED: 'Aguardando sua confirmação', CONFIRMED: 'Confirmado como resolvido', PERSISTS: 'Ainda acontece' },
    fulfillment: {
      NOT_STARTED: 'Não iniciado',
      IN_PROGRESS: 'Em andamento',
      IN_REVIEW: 'Em revisão',
      AWAITING_DEPLOYMENT: 'Aguardando implantação em produção',
      AWAITING_ACTIVATION: 'Aguardando ativação',
      DELIVERED: 'Entregue',
      NONE_LINKED: 'Ainda não planejado',
    },
    channel: { WEB: 'Web', SLACK: 'Slack', MCP: 'Assistente de IA', API: 'API', EMAIL: 'E-mail', JIRA_IMPORT: 'Importação do Jira', SYSTEM: 'Sistema' },
    scope: { NONE: 'Não se aplica', AWAITING_SCOPE: 'Aguardando escopo de entrega', UNCONFIRMED: 'Escopo não confirmado', CONFIRMED: 'Escopo confirmado' },
    milestone: { START: 'Iniciado', SCOPE_CHANGE: 'Escopo alterado', BLOCKER: 'Bloqueio', VERIFICATION: 'Verificação', PR_UPDATE: 'Pull request', HANDOFF: 'Passagem', SESSION_END: 'Sessão encerrada', NOTE: 'Nota' },
    client: { CLAUDE_CODE: 'Claude Code', CODEX: 'Codex', CLAUDE: 'Claude', CHATGPT: 'ChatGPT', OTHER: 'Outro cliente' },
  },
  actions: {
    request: {
      submit: 'Enviar solicitação',
      cancel: 'Cancelar solicitação',
      ask_information: 'Pedir informações',
      answer_information: 'Enviar resposta',
      accept: 'Aceitar',
      reject: 'Recusar',
      mark_duplicate: 'Marcar como duplicada',
      fulfill: 'Marcar como atendida',
      report_persistence: 'Informar que continua',
      fulfillment_invalidated: 'Reabrir para atenção',
      accept_correction: 'Aceitar correção',
      fulfill_after_review: 'Resolver após revisão',
      reconsider: 'Reconsiderar',
    },
    work: {
      start: 'Iniciar',
      request_review: 'Pedir revisão',
      request_changes: 'Pedir ajustes',
      integration_observed: 'Integrado',
      production_verified: 'Verificado em produção',
      complete_deliverable: 'Concluir',
      approve_deliverable: 'Aprovar',
      cancel: 'Cancelar trabalho',
      reopen: 'Reabrir',
      coverage_lost: 'Cobertura perdida',
    },
  },
  myWork: {
    title: 'Meu trabalho',
    greeting: 'Olá, {{name}}',
    subtitle: 'O que precisa da sua atenção hoje.',
    assigned: 'Atribuído a mim',
    assignedEmpty: 'Nada atribuído a você agora.',
    myRequests: 'Minhas solicitações',
    myRequestsEmpty: 'Você ainda não registrou solicitações.',
    needsMe: 'Aguardando você',
    needsMeEmpty: 'Nada está aguardando você.',
    blocked: 'Bloqueado',
    triageInbox: 'Caixa de triagem',
    updates: 'Atualizações recentes',
    updatesEmpty: 'Ainda não há atualizações.',
    following: 'Seguindo',
    followingEmpty: 'Siga trabalhos ou solicitações para vê-los aqui.',
    stats: { open: 'Trabalho aberto', inReview: 'Em revisão', blocked: 'Bloqueados', attention: 'Solicitações que requerem atenção' },
  },
  requests: {
    move: { noProject: 'Sem projeto', title: 'Mover para {{name}}', hint: 'Mover muda quem pode ler esta solicitação, seus comentários e arquivos.', restrictedAfter: 'Após mover, a solicitação ficará restrita ao público do projeto.', companyAfter: 'Após mover, a solicitação ficará visível para toda a empresa.', losesAccess: 'Estas pessoas perderiam acesso:', nobodyLoses: 'Ninguém envolvido perde acesso.', reassignFirst: 'O responsável perderia acesso. Reatribua a solicitação primeiro.', confirm: 'Mover solicitação' },
    activation: { pending: 'Ativação pendente:', observed: 'Ativação observada por {{name}} em {{time}}', notRequired: 'Não requer uma ativação separada.', require: 'Exigir ativação', record: 'Registrar ativação', waive: 'Dispensar ativação', requireHint: 'Use quando implantar não basta, por exemplo quando um feature flag precisa ser ligado. A solicitação fica aceita até registrar a ativação.', recordHint: 'Registre quem observou a mudança ativa e a evidência. Fica auditado.', waiveHint: 'A ativação deixará de ser obrigatória. O motivo fica auditado.', noteLabel: 'O que precisa ser ativado?', evidenceLabel: 'Evidência', reasonLabel: 'Motivo' },
    duplicates: { title: 'Possíveis duplicatas', hint: 'Solicitações semelhantes que você pode ver. Ao marcar, cada solicitante continua informado.', mark: 'Marcar como duplicata desta' },
    title: 'Solicitações',
    subtitle: 'Problemas, ideias e pedidos de toda a Vammo.',
    tabs: { inbox: 'Entrada', mine: 'Minhas', attention: 'Requer atenção', following: 'Seguindo', all: 'Todas' },
    empty: 'Nenhuma solicitação aqui.',
    emptyInbox: 'A caixa de entrada está vazia. Novas solicitações aparecem aqui para triagem.',
    columns: { key: 'Chave', title: 'Título', status: 'Status', priority: 'Prioridade', author: 'Solicitante', assignee: 'Responsável', team: 'Time', updated: 'Atualizado', source: 'Origem' },
    detail: {
      problem: 'Problema',
      currentBehavior: 'O que acontece hoje',
      expectedOutcome: 'Resultado esperado',
      impact: 'Impacto',
      impactUnknown: 'Impacto ainda desconhecido',
      reproduction: 'Como reproduzir',
      affectedArea: 'Área afetada',
      progress: 'Progresso',
      decisions: 'Histórico de decisões',
      comments: 'Comentários',
      linkedWork: 'Trabalho vinculado',
      linkedWorkEmpty: 'Nenhum trabalho vinculado ainda.',
      required: 'Obrigatório',
      optional: 'Opcional',
      hiddenWork: 'Parte do trabalho vinculado é restrita e não é exibida.',
      pendingQuestion: 'O time perguntou',
      answerPlaceholder: 'Responda à pergunta…',
      duplicateOf: 'Duplicada de',
      decisionReason: 'Nota da decisão',
      source: 'Origem',
      triage: 'Triagem',
      triageTeam: 'Time de triagem',
      followers: 'Seguir',
      following: 'Seguindo',
      linkWork: 'Vincular trabalho',
      linkWorkSearch: 'Busque trabalho por chave ou título',
      unlink: 'Desvincular',
    },
    confirm: {
      fromEmail: 'Escolha sua resposta abaixo. Nada é registrado até você clicar.',
      title: 'Isto foi resolvido para você?',
      body: 'O time marcou esta solicitação como resolvida. Diga se funcionou para você.',
      confirmed: 'Sim, está resolvido',
      persists: 'Não, ainda acontece',
      commentPlaceholder: 'Adicione detalhes (opcional)',
      thanks: 'Obrigado por confirmar.',
      reported: 'Obrigado — o time vai revisar novamente.',
      generation: 'Entrega nº {{generation}}',
    },
    dialogs: {
      rejectTitle: 'Recusar solicitação',
      duplicateTitle: 'Marcar como duplicada',
      duplicateSearch: 'Encontre a solicitação principal',
      askTitle: 'Pedir informações',
      askPlaceholder: 'O que você precisa saber?',
      fulfillTitle: 'Marcar como atendida',
      fulfillDirect: 'Descreva o resultado entregue',
      reviewTitle: 'Resolver após revisão',
      reviewPlaceholder: 'Explique por que o resultado atual agora atende à solicitação',
      correctionTitle: 'Aceitar correção',
      correctionWork: 'Item de trabalho corretivo (opcional)',
      cancelTitle: 'Cancelar solicitação',
      reconsiderTitle: 'Reconsiderar solicitação',
    },
  },
  intake: {
    title: 'Nova solicitação',
    subtitle: 'Descreva o que está acontecendo. Você não precisa saber como resolver.',
    tabs: { assistant: 'Guiado', form: 'Formulário' },
    assistantIntro: 'Conte o problema ou a ideia com suas palavras. Vou perguntar só o que faltar.',
    assistantPlaceholder: 'Digite sua resposta…',
    assistantUnavailable: 'O assistente está indisponível agora. Use o formulário; tudo fica salvo.',
    assistant: {
      ack: 'Obrigado, salvei isso no rascunho.',
      askProblem: 'O que está acontecendo, e onde?',
      askExpected: 'O que deveria acontecer?',
      askImpact: 'Quem é afetado e quanto isso importa? Tudo bem dizer que não sabe.',
      askReproduction: 'Se for um bug: como alguém consegue ver o problema acontecer, e com que frequência?',
      ready: 'Já tenho o que a triagem precisa. Revise o resumo e envie quando estiver certo.',
      fallback: 'O assistente está indisponível, então salvei sua resposta como está.',
    },
    fields: {
      title: 'Título curto',
      titlePlaceholder: 'ex.: O app não mostra o histórico de trocas',
      problem: 'Qual é o problema?',
      problemPlaceholder: 'Descreva a situação e quem é afetado',
      currentBehavior: 'O que acontece hoje?',
      expectedOutcome: 'O que deveria acontecer?',
      impact: 'Impacto',
      impactPlaceholder: 'Quem ou o que é afetado, e quanto?',
      impactUnknown: 'Ainda não sei o impacto',
      reproduction: 'Passos para reproduzir (para bugs)',
      affectedArea: 'Área ou produto afetado',
      language: 'Escrito em',
      visibility: 'Quem pode ver',
      team: 'Encaminhar ao time',
      teamAuto: 'Deixar a triagem decidir',
      priority: 'Prioridade',
      evidence: 'Anexos',
    },
    duplicates: 'Solicitações possivelmente relacionadas',
    duplicatesHelp: 'Verifique se alguma delas já cobre sua solicitação.',
    review: 'Revisar e enviar',
    reviewHelp: 'Confira o resumo abaixo. Você ainda pode editar antes de enviar.',
    missing: 'Ainda falta: {{fields}}',
    saved: 'Rascunho salvo',
    submitted: 'Solicitação {{key}} enviada',
    draftNote: 'Rascunhos são privados até você enviá-los.',
  },
  work: {
    title: 'Trabalho',
    subtitle: 'Tudo em andamento entre times, projetos e repositórios.',
    views: { list: 'Lista', board: 'Quadro' },
    empty: 'Nenhum trabalho corresponde a esses filtros.',
    columns: { key: 'Chave', title: 'Título', phase: 'Fase', priority: 'Prioridade', type: 'Tipo', assignee: 'Responsável', project: 'Projeto', team: 'Time', updated: 'Atualizado', delivery: 'Entrega' },
    filters: { phase: 'Fase', type: 'Tipo', priority: 'Prioridade', assignee: 'Responsável', project: 'Projeto', team: 'Time', blocked: 'Somente bloqueados', provisional: 'Somente provisórios', includeCanceled: 'Incluir cancelados', label: 'Etiqueta' },
    bulk: { selected: '{{count}} selecionados', setPriority: 'Definir prioridade', assign: 'Atribuir', addLabel: 'Adicionar etiqueta', clear: 'Limpar seleção' },
    board: { moveTo: 'Mover para…', dropRejected: 'Esse movimento não é permitido: {{reason}}', productionHint: 'Trabalho de produção só fica Concluído com implantações verificadas.' },
    create: {
      title: 'Novo item de trabalho',
      responsibility: 'Responsável',
      team: 'Time',
      personal: 'Pessoal (eu)',
      project: 'Projeto',
      noProject: 'Sem projeto',
      type: 'Tipo',
      policy: 'Conclusão',
      description: 'Descrição',
      criteria: 'Critérios de aceite',
      addCriterion: 'Adicionar critério',
      criterionPlaceholder: 'Resultado observável…',
      assignee: 'Responsável',
      labels: 'Etiquetas',
      labelsPlaceholder: 'separadas, por vírgula',
      created: '{{key}} criado',
    },
    provisional: {
      confirm: 'Confirmar como trabalho novo',
      merge: 'Mesclar com trabalho existente',
      mergeTitle: 'Mesclar com trabalho existente',
      mergeHint: 'A chave vira um alias do item escolhido. Contribuições, sessões, pull requests e vínculos com solicitações são transferidos; nada é apagado.',
      mergeInto: 'Mesclar com {{key}}',
      confirmed: 'Confirmado como trabalho novo',
      merged: 'Mesclado com {{key}}',
    },
    detail: {
      overview: 'Visão geral',
      activity: 'Atividade',
      progress: 'Progresso',
      delivery: 'Entrega',
      history: 'Histórico',
      description: 'Descrição',
      noDescription: 'Ainda sem descrição.',
      criteria: 'Critérios de aceite',
      noCriteria: 'Sem critérios de aceite.',
      properties: 'Propriedades',
      owner: 'Dono',
      reviewer: 'Revisor',
      repositories: 'Repositórios',
      noRepositories: 'Sem repositórios — tudo bem para trabalho sem código.',
      labels: 'Etiquetas',
      blockers: 'Bloqueios',
      addBlocker: 'Adicionar bloqueio',
      blockerReason: 'O que está bloqueando?',
      preventsCompletion: 'Impede a conclusão',
      resolveBlocker: 'Resolver',
      relations: 'Trabalho relacionado',
      addRelation: 'Vincular trabalho',
      relationKinds: { PARENT_OF: 'Pai de', DEPENDS_ON: 'Depende de', RELATES_TO: 'Relacionado a', DUPLICATES: 'Duplica' },
      requiresCompletion: 'Necessário para concluir',
      contributors: 'Contribuidores',
      linkedRequests: 'Solicitações',
      outcome: 'Resultado',
      outcomePlaceholder: 'O que foi entregue?',
      complete: 'Concluir entregável',
      criterionStatus: { OPEN: 'Aberto', MET: 'Atendido', NOT_MET: 'Não atendido', WAIVED: 'Dispensado' },
      episodes: 'Episódios de conclusão',
      provisionalNote: 'Criado provisoriamente por um agente; confirme ou mescle.',
      blockedNote: 'Bloqueado',
      awaitingDeployment: 'Aguardando verificação da implantação',
      sessions: 'Sessões de agentes',
      evidence: 'Evidências',
      noEvidence: 'Nenhuma evidência anexada.',
      timelineEmpty: 'Ainda sem histórico.',
    },
  },
  projects: {
    addManager: 'Adicionar gestor',
    addTeam: 'Adicionar time responsável',
    archive: 'Arquivar este projeto',
    archiveHint: 'Projetos arquivados saem de listas e seletores; seus trabalhos e histórico continuam visíveis.',
    title: 'Projetos',
    subtitle: 'Projetos agrupam trabalho; repositórios são opcionais.',
    new: 'Novo projeto',
    empty: 'Ainda não há projetos.',
    key: 'Chave',
    name: 'Nome',
    description: 'Descrição',
    managers: 'Gestores',
    owningTeams: 'Times responsáveis',
    openWork: '{{count}} abertos',
    defaultPolicy: 'Conclusão padrão',
    requiresReview: 'Exigir revisão independente para entregáveis',
    settings: 'Configurações',
    visibility: 'Visibilidade',
    repositories: 'Repositórios',
  },
  teams: {
    title: 'Times',
    members: 'Membros',
    manager: 'Gestor',
    member: 'Membro',
    addMember: 'Adicionar membro',
    remove: 'Remover',
    new: 'Novo time',
    slug: 'Identificador',
  },
  visibility: {
    title: 'Visibilidade',
    grants: 'Pessoas, times e grupos',
    addGrant: 'Adicionar acesso',
    searchPrincipal: 'Busque pessoas, times ou grupos',
    inherit: 'Restrições dos projetos pais sempre se aplicam.',
    changed: 'Visibilidade atualizada',
  },
  settings: {
    title: 'Configurações',
    profile: 'Perfil',
    displayName: 'Nome de exibição',
    language: 'Idioma',
    timezone: 'Fuso horário',
    notifications: 'Notificações',
    identities: 'Contas vinculadas',
    noIdentities: 'Nenhuma conta vinculada.',
    roles: 'Acesso',
    basic: 'Acesso básico',
    github: {
      addLabel: 'Adicionar uma conta do GitHub',
      hint: 'Seu usuário do GitHub, por exemplo uma conta pessoal com a qual você às vezes faz commits. Contas que fazem commits com seu e-mail da Vammo são vinculadas automaticamente.',
      placeholder: 'usuário',
      add: 'Adicionar',
      added: 'Conta do GitHub adicionada',
      remove: 'Remover',
      removed: 'Conta do GitHub removida',
      confirmRemove: 'Remover esta conta?',
      method: { self: 'Adicionada por você', email: 'Verificada pelo e-mail do commit', admin: 'Vinculada por um administrador', other: 'Vinculada' },
      errors: {
        notFound: 'Nenhuma conta do GitHub tem esse usuário.',
        notUser: 'Só é possível adicionar contas pessoais do GitHub, não organizações nem bots.',
        taken: 'Esta conta do GitHub já está vinculada a outra pessoa. Peça a um administrador.',
        tooMany: 'Você já tem o número máximo de contas do GitHub.',
        unavailable: 'Não foi possível contatar o GitHub. Tente novamente em instantes.',
      },
    },
  },
  admin: {
    title: 'Administração',
    users: 'Usuários e papéis',
    groups: 'Grupos de visibilidade',
    integrations: 'Integrações',
    exceptions: 'Exceções',
    imports: 'Importação do Jira',
    audit: 'Registro de auditoria',
    operations: 'Operações',
    roles: 'Papéis',
    capabilities: 'Capacidades',
    status: 'Status',
    suspend: 'Suspender',
    reactivate: 'Reativar',
    lastLogin: 'Último login',
    changeAccess: 'Alterar acesso',
    reasonRequired: 'Um motivo é registrado no log de auditoria.',
    reason: { title: 'Registrar um motivo', label: 'Motivo', hint: 'O motivo fica no registro de auditoria.', confirm: 'Confirmar' },
    integ: { lastSuccess: 'Último sucesso', lastAttempt: 'Última tentativa', lastError: 'Último erro', circuit: 'Circuito aberto até', cursor: 'Cursor', probe: 'Testar', reconcile: 'Reconciliar', reconcileQueued: 'Reconciliação enfileirada', liveVerified: 'Verificado ao vivo', health: { HEALTHY: 'Saudável', DEGRADED: 'Degradado', FAILING: 'Falhando', DISABLED: 'Desativado', UNVERIFIED: 'Não verificado' }, modes: { live: 'Ao vivo', fixture: 'Fixture', disabled: 'Desativado' } },
    deliveries: { title: 'Entregas de notificações', hint: 'Um envio incerto pode já ter chegado à pessoa. Verifique a evidência do provedor antes de tentar de novo.', filter: 'Status da entrega', filters: { DELIVERY_UNKNOWN: 'Incertas ou com falha', BOUNCED: 'Devolvidas ou suprimidas', SENT: 'Enviadas', ALL: 'Todas' }, empty: 'Nenhuma entrega precisa de atenção.', attempts: '{{count}} tentativa(s)', retry: 'Tentar novamente', retryTitle: 'Tentar esta entrega novamente', retryHint: 'A mensagem pode ser enviada de novo. O motivo fica no registro de auditoria.', retried: 'Nova tentativa na fila' },
    services: { title: 'Serviços e ambientes', hint: 'Aprove quais repositórios constroem cada serviço e quais ambientes são produção. A cobertura usa apenas mapeamentos aprovados.', empty: 'Nenhum serviço descoberto ainda.', repositories: 'Repositórios', environments: 'Ambientes', buildPath: 'Caminho de build (opcional)', buildPathFor: 'Caminho de build de {{name}}', classificationFor: 'Classificação de {{name}}', noRepositories: 'Nenhum repositório mapeado.', approve: 'Aprovar mapeamento', approved: 'Mapeamento aprovado', classes: { PRODUCTION: 'Produção', STAGING: 'Staging', DEVELOPMENT: 'Desenvolvimento', PREVIEW: 'Preview', OTHER: 'Outro' } },
    identities: { action: 'Contas vinculadas', title: 'Contas vinculadas', hint: 'Vincule uma conta do GitHub ou Jira apenas quando tiver confirmado que pertence a esta pessoa. Os vínculos são auditados.', none: 'Nenhuma conta vinculada.', add: 'Vincular uma conta', provider: 'Provedor', search: 'Buscar por usuário ou ID', candidates: 'Contas que podem ser vinculadas', historical: 'Histórico do Jira', unmapped: 'Vista {{count}} vez(es)', noCandidates: 'Nenhuma conta sem vínculo encontrada.', link: 'Vincular conta', linked: 'Conta vinculada', unlink: 'Desvincular' },
    exc: { empty: 'Nenhuma exceção aberta.', resolve: 'Resolver', ignore: 'Ignorar', open: 'Abrir', occurrences: '{{count}} ocorrência(s)', filterKind: 'Tipo', all: 'Todos os tipos', kinds: { UNMATCHED_WORK: 'Trabalho sem associação', UNCERTAIN_ASSOCIATION: 'Associação incerta', UNMAPPED_IDENTITY: 'Identidade sem mapeamento', UNMAPPED_REPOSITORY: 'Repositório sem mapeamento', UNMAPPED_SERVICE: 'Serviço sem mapeamento', CONNECTOR_FAILURE: 'Falha de conector', DUPLICATE_CORRECTION: 'Correção de duplicado', WEBHOOK_INTEGRITY: 'Integridade de webhook', DEPLOYMENT_ORDERING: 'Ordem de deploys', DELIVERY_UNKNOWN: 'Entrega incerta', IMPORT_EXCEPTION: 'Exceção de importação', ACL_QUARANTINE: 'Quarentena de acesso', SCOPE_REVIEW: 'Revisão de escopo', COMPLETION_BLOCKED: 'Conclusão bloqueada' } },
    ops: { noAlerts: 'Sem alertas ativos', outbox: 'Outbox pendente', worker: 'Worker', healthy: 'Saudável', stale: 'Sem heartbeat', aiTokens: 'Tokens de IA hoje', queue: 'Fila', queued: 'Na fila', active: 'Ativos', oldest: 'Espera mais antiga', dead: 'Dead letters', replay: 'Reprocessar', deadEmpty: 'Nenhum job em dead letter.' },
    imp: { mode: 'Modo', projects: 'Chaves de projeto (separadas por vírgula; vazio usa os projetos aprovados)', start: 'Iniciar', queued: 'Importação enfileirada', resume: 'Retomar', empty: 'Nenhuma execução de importação ainda.', exceptions: '{{count}} exceção(ões)', mapping: 'Mapeamentos', mappingHelp: 'Execute a descoberta primeiro. Aprove cada projeto antes de importar amostra, completo ou delta. Níveis de segurança sem mapeamento ficam em quarentena para administradores.', save: 'Salvar mapeamentos', saved: 'Mapeamentos salvos', approved: 'Aprovado', targetProject: 'Projeto de destino', targetTeam: 'Time de triagem/responsável', none: 'Nenhum', requestTypes: 'Tipos importados como solicitações', statusMap: 'Mapeamento de status', securityLevels: 'Níveis de segurança', securityGroup: 'Visível para o grupo', quarantine: 'Quarentena (só administradores)', reconciliation: 'Reconciliação', modes: { DISCOVERY: 'Descoberta', DRY_RUN: 'Simulação', SAMPLE: 'Amostra', FULL: 'Importação completa', DELTA: 'Delta', RECONCILE: 'Reconciliar' }, statuses: { QUEUED: 'Na fila', RUNNING: 'Em execução', PAUSED: 'Pausada', SUCCEEDED: 'Concluída', FAILED: 'Falhou', CANCELED: 'Cancelada' } },
    slackDest: { title: 'Destinos de progresso no Slack', help: 'Canais internos aprovados que recebem o progresso de um projeto ou time. Itens restritos só publicam um link, a menos que o destino seja aprovado para conteúdo restrito e todos os membros sejam membros plenos do workspace.', scope: 'Escopo', project: 'Projeto', team: 'Time', workspace: 'ID do workspace', channel: 'ID do canal', restricted: 'Aprovado para conteúdo restrito', milestones: 'Marcos', add: 'Salvar destino', remove: 'Remover', empty: 'Nenhum destino configurado.', saved: 'Destino salvo', milestoneNames: { REQUEST_RECEIVED: 'Solicitação recebida', REQUEST_ACCEPTED: 'Solicitação aceita', REQUEST_REJECTED: 'Solicitação rejeitada', REQUEST_RESOLVED: 'Solicitação resolvida', REQUEST_NEEDS_ATTENTION: 'Precisa de atenção', WORK_STARTED: 'Trabalho iniciado', WORK_BLOCKED: 'Trabalho bloqueado', WORK_DELIVERED: 'Trabalho entregue' } },
  },
  reports: {
    notes: {
      sourceNotConnected: '{{source}} não está conectado; seus valores são desconhecidos, não zero.',
      sourceNotLive: 'Os dados de {{source}} vêm do modo {{mode}}, não são evidência real.',
      sourceNeverSynced: '{{source}} ainda não sincronizou com sucesso.',
      duplicatesIncluded: '{{count}} destas solicitações estão marcadas como duplicatas.',
      reconsideredExcluded: '{{count}} decisões reconsideradas no período ficam fora da taxa.',
      generationsAcrossRequests: '{{generations}} gerações de atendimento em {{requests}} solicitações distintas.',
      mixedBases: 'Bases de conclusão misturadas ({{bases}}); escolha uma para comparar coisas equivalentes.',
      partialCohorts: 'A janela de acompanhamento vai de cada primeira conclusão até agora; coortes recentes são parciais.',
      currentState: 'Estado atual no momento da consulta; estados passados não são reconstruídos para esta métrica.',
      rolledBack: '{{count}} implantações revertidas aparecem separadas.',
      noIncidentSource: 'Nenhuma fonte de incidentes está conectada; o tempo de recuperação fica indisponível e nunca é inferido das implantações.',
      activityNotProductivity: 'Contribuições são indicadores de atividade, não uma medida de produtividade.',
      prAttribution: 'A autoria é indicada por pull request, não por linha. Exclusões de arquivos gerados só valem com dados completos de arquivos.',
      captureDenominator: 'Denominador: pull requests observados em repositórios vinculados a projetos; trabalho fora da plataforma não tem denominador.',
      providerErrors: '{{count}} chamadas ao provedor falharam.',
    },
    filters: { any: 'Qualquer', source: 'Origem', mine: 'Só minhas contribuições' },
    chartLabel: 'Gráfico de {{metric}} por grupo',
    title: 'Relatórios',
    subtitle: 'Métricas calculadas a partir de fatos registrados, com o seu acesso aplicado. Dados desconhecidos nunca aparecem como zero.',
    metric: 'Métrica',
    period: 'Período',
    groupBy: 'Agrupar por',
    basis: 'Base de conclusão',
    anyBasis: 'Todas as bases',
    firstOnly: 'Só a primeira conclusão',
    run: 'Executar',
    export: 'Exportar CSV',
    exporting: 'Preparando exportação…',
    download: 'Baixar CSV',
    total: 'Total',
    count: 'Quantidade',
    unavailable: 'Indisponível',
    median: 'Mediana',
    p85: 'Percentil 85',
    coverage: 'Cobertura',
    overlapping: 'Os grupos se sobrepõem: uma tarefa pode aparecer em vários grupos, então as linhas não somam o total.',
    empty: 'Sem dados neste período.',
    tierLabel: 'Nível',
    formula: 'Fórmula v{{version}}',
    watermark: 'Dados de {{time}}',
    definition: 'Definição',
    last7: 'Últimos 7 dias',
    last30: 'Últimos 30 dias',
    last90: 'Últimos 90 dias',
    thisYear: 'Este ano',
    from: 'De',
    to: 'Até',
    group: 'Grupo',
    value: 'Valor',
    ratio: '{{num}} de {{den}}',
    tiers: { GENERAL: 'Geral', TECHNICAL: 'Técnico', SENSITIVE: 'Sensível' },
    coverageStatus: { COMPLETE: 'Completa', PARTIAL: 'Parcial', UNKNOWN: 'Desconhecida' },
    groups: { none: 'Sem agrupamento', team: 'Time', project: 'Projeto', type: 'Tipo', priority: 'Prioridade', week: 'Semana', month: 'Mês', repository: 'Repositório', service: 'Serviço', person: 'Pessoa', outcome: 'Resultado', source: 'Origem' },
    metrics: {
      requests_created: { name: 'Solicitações criadas', help: 'Solicitações enviadas pela data de envio.' },
      request_first_response: { name: 'Tempo até a primeira resposta', help: 'Do envio até a primeira decisão humana de triagem.' },
      request_acceptance_rate: { name: 'Taxa de aceitação', help: 'Primeiras aceitações sobre aceitas mais rejeitadas.' },
      requests_fulfilled: { name: 'Solicitações resolvidas', help: 'Solicitações distintas resolvidas no período.' },
      request_lead_time: { name: 'Lead time da solicitação', help: 'Do envio até a resolução, por resolução.' },
      work_completed: { name: 'Trabalho concluído', help: 'Itens de trabalho distintos concluídos no período.' },
      work_cycle_time: { name: 'Tempo de ciclo', help: 'Do início à conclusão de cada episódio.' },
      work_in_progress: { name: 'Trabalho em andamento', help: 'Itens em andamento, revisão ou integrados agora.' },
      blocked_time: { name: 'Tempo bloqueado', help: 'União dos intervalos bloqueados por item no período.' },
      review_wait: { name: 'Espera por revisão', help: 'Do pedido de revisão até a decisão.' },
      integration_to_production: { name: 'Da integração à produção', help: 'Da integração até a entrega verificada em produção.' },
      deployment_frequency: { name: 'Frequência de deploy', help: 'Deploys bem-sucedidos em produção.' },
      deployment_failure_rate: { name: 'Taxa de falha de deploy', help: 'Falhos sobre bem-sucedidos mais falhos em produção.' },
      reopen_rate: { name: 'Taxa de reabertura', help: 'Trabalho concluído que depois foi reaberto.' },
      recovery_time: { name: 'Tempo de recuperação', help: 'Requer evidência de incidentes; indisponível sem uma fonte.' },
      contribution_activity: { name: 'Contribuições', help: 'Contribuições observadas de implementação, revisão e outras.' },
      code_additions: { name: 'Linhas adicionadas', help: 'Adições reportadas pelo provedor em PRs mesclados.' },
      code_deletions: { name: 'Linhas removidas', help: 'Remoções reportadas pelo provedor em PRs mesclados.' },
      capture_coverage: { name: 'Cobertura de captura', help: 'PRs observados vinculados a trabalho confirmado.' },
      requester_confirmation: { name: 'Confirmação do solicitante', help: 'Confirmado, persiste ou sem resposta por resolução.' },
      integrated_ai_usage: { name: 'Uso de IA', help: 'Tokens reportados pelo provedor para tradução e intake.' },
    },
  },
  attachments: {
    title: 'Arquivos',
    add: 'Anexar arquivos',
    empty: 'Nenhum arquivo anexado ainda.',
    uploading: 'Enviando {{name}}…',
    scanning: 'Verificando malware',
    rejected: 'Rejeitado',
    download: 'Baixar',
    remove: 'Remover arquivo',
    removed: 'Arquivo removido',
    tooLarge: '{{name}} tem mais de {{max}} MiB.',
    tooMany: 'Você pode anexar no máximo {{max}} arquivos por vez.',
    uploaded: '{{count}} arquivo(s) enviado(s); ficam disponíveis após a verificação de malware.',
    pendingNote: 'Os arquivos ficam em quarentena até a verificação terminar.',
  },
  savedViews: {
    title: 'Visões',
    mine: 'Minhas visões',
    sharedWithEveryone: 'Visões compartilhadas',
    shared: 'Compartilhada',
    empty: 'Nenhuma visão salva ainda.',
    saveCurrent: 'Salvar filtros atuais…',
    name: 'Nome da visão',
    shareLabel: 'Compartilhar com todos (só os filtros; cada pessoa continua vendo apenas o que pode acessar)',
    hint: 'Uma visão salva guarda os filtros, nunca os resultados.',
    saved: 'Visão salva',
    deleted: 'Visão excluída',
    delete: 'Excluir visão',
  },
  slack: {
    modalTitle: 'Criar solicitação Vammo',
    reviewTitle: 'Revisar solicitação',
    next: 'Próximo',
    submit: 'Enviar',
    cancel: 'Cancelar',
    close: 'Fechar',
    privacyNote: 'Só você vê este formulário. A solicitação é privada até você enviá-la.',
    fields: { title: 'Título curto', problem: 'O que está acontecendo?', expected: 'O que deveria acontecer?', impact: 'Quem é afetado e quanto? (deixe vazio se não souber)' },
    impactUnknown: 'Desconhecido por enquanto',
    duplicates: 'Solicitações possivelmente relacionadas',
    submitted: 'Solicitação *{{key}}* enviada. Acompanhe aqui: {{url}}',
    linkPrompt: 'Para criar solicitações pelo Slack, vincule sua conta do Slack à sua conta Vammo (link privado, válido por 10 minutos): {{url}}',
    notLinked: 'Sua conta do Slack ainda não está vinculada. Execute /vammo-work de novo.',
    expired: 'Este rascunho não está mais disponível. Comece de novo com /vammo-work.',
    required: 'Obrigatório',
    unavailable: 'Não foi possível abrir o formulário. Tente de novo ou use o app web.',
    progress: '*{{key}}* {{title}} — {{status}}\n{{url}}',
    progressLinkOnly: 'Um item acompanhado foi atualizado. Abra no Vammo Issue Tracker: {{url}}',
    linkTitle: 'Vincular conta do Slack',
    linkBody: 'Vincular o usuário do Slack {{handle}} à sua conta Vammo? As solicitações criadas pelo Slack serão registradas em seu nome.',
    linkConfirm: 'Vincular conta',
    linkDone: 'Sua conta do Slack foi vinculada. Pode fechar esta aba e executar /vammo-work de novo.',
    linkInvalid: 'Este link expirou ou já foi usado. Execute /vammo-work no Slack para obter um novo.',
  },
  notifications: {
    preferences: {
      title: 'Configurações de notificação',
      event: 'Evento',
      email: 'E-mail',
      browser: 'Navegador',
      immediate: 'Na hora',
      digest: 'Resumo diário',
      muted: 'Desativado',
      on: 'Ativado',
      off: 'Desativado',
    },
    events: {
      REQUEST_RECEIVED: 'Recebemos sua solicitação',
      REQUEST_NEEDS_INFORMATION: 'Precisamos de mais informações',
      REQUEST_ACCEPTED: 'Sua solicitação foi aceita',
      REQUEST_REJECTED: 'Sua solicitação não foi aceita',
      REQUEST_WORK_STARTED: 'O trabalho na sua solicitação começou',
      REQUEST_RESOLVED: 'Sua solicitação foi resolvida',
      REQUEST_NEEDS_ATTENTION: 'Uma solicitação precisa de atenção',
      WORK_ASSIGNED: 'Trabalho atribuído a você',
      WORK_BLOCKED: 'Algo que você segue está bloqueado',
      COMMENT_ADDED: 'Novo comentário em algo que você segue',
      MENTIONED: 'Você foi mencionado',
    },
    browser: {
      title: 'Notificações do navegador',
      enable: 'Ativar neste navegador',
      disable: 'Desativar neste navegador',
      test: 'Enviar um teste',
      enabled: 'As notificações do navegador estão ativadas',
      disabled: 'As notificações estão desativadas neste navegador',
      testSent: 'Notificação de teste enviada',
      testNone: 'Nenhum navegador aceitou o teste. Desative e ative as notificações de novo.',
      blockedHelp: 'As notificações estão bloqueadas para este site. Permita-as nas configurações do site no navegador (o ícone ao lado do endereço).',
      devices: 'Navegadores que recebem notificações',
      unknownDevice: 'Navegador',
      forget: 'Esquecer',
      state: {
        unsupported: 'Este navegador não consegue mostrar notificações. No iPhone e iPad, adicione o tracker à Tela de Início primeiro.',
        blocked: 'As notificações estão bloqueadas para este site. Permita-as nas configurações do site no navegador e recarregue a página.',
        off: 'Receba atribuições, menções e novidades do que você segue, mesmo com o tracker fechado.',
        on: 'Este navegador mostra suas notificações.',
      },
    },
  },
  push: {
    testTitle: 'As notificações estão ativadas',
    testBody: 'Este navegador mostrará suas notificações do Vammo Issue Tracker.',
  },
  email: {
    greeting: 'Olá {{name}},',
    open: 'Abrir no Vammo Issue Tracker',
    footer: 'Você recebe isto porque participa deste registro. Altere as notificações no seu perfil.',
    actionConfirm: 'Sim, está resolvido',
    actionPersists: 'Não, ainda acontece',
    actionComment: 'Deixar um comentário',
    confirmHint: 'Diga ao time se funcionou para você: abra a solicitação e escolha "Sim, está resolvido" ou "Não, ainda acontece". Abrir este e-mail ou link nunca registra uma resposta por si só.',
    digestSubject: 'Seu resumo do Vammo Issue Tracker',
    events: {
      REQUEST_RECEIVED: { subject: '[{{key}}] Recebemos sua solicitação', body: 'Sua solicitação "{{title}}" foi recebida e aguarda triagem.' },
      REQUEST_NEEDS_INFORMATION: { subject: '[{{key}}] Precisamos de mais informações', body: 'O time precisa de mais informações sobre "{{title}}".' },
      REQUEST_ACCEPTED: { subject: '[{{key}}] Sua solicitação foi aceita', body: 'Sua solicitação "{{title}}" foi aceita. Aceitar não é uma data de entrega; você será avisado quando o trabalho começar.' },
      REQUEST_REJECTED: { subject: '[{{key}}] Sua solicitação não foi aceita', body: 'Sua solicitação "{{title}}" não foi aceita. Abra-a para ler o motivo.' },
      REQUEST_WORK_STARTED: { subject: '[{{key}}] O trabalho começou', body: 'O trabalho em "{{title}}" começou.' },
      REQUEST_RESOLVED: { subject: '[{{key}}] Resolvida — confirme, por favor', body: 'O time resolveu "{{title}}".' },
      REQUEST_NEEDS_ATTENTION: { subject: '[{{key}}] Requer atenção', body: 'O solicitante informa que "{{title}}" ainda acontece, ou a entrega necessária foi perdida.' },
      WORK_ASSIGNED: { subject: '[{{key}}] Atribuído a você', body: '"{{title}}" foi atribuído a você.' },
      WORK_BLOCKED: { subject: '[{{key}}] Bloqueado', body: '"{{title}}" está bloqueado.' },
      WORK_DONE: { subject: '[{{key}}] Concluído', body: '"{{title}}" foi concluído.' },
      COMMENT_ADDED: { subject: '[{{key}}] Novo comentário', body: 'Há um novo comentário em "{{title}}".' },
      MENTIONED: { subject: '[{{key}}] Você foi mencionado', body: 'Você foi mencionado em "{{title}}".' },
    },
  },
  time: {
    justNow: 'agora mesmo',
  },
};
